var map = {
	"./kgtech_audit.postman_collection.json": 130,
	"./kgtech_config.postman_collection.json": 1049,
	"./kgtech_monitoring.postman_collection.json": 2073,
	"./kgtech_security.postman_collection.json": 1729,
	"./kgtech_workflow.postman_collection.json": 7488,
	"./mxpay_message_iso20022.postman_collection.json": 3569,
	"./mxpay_message_mt.postman_collection.json": 4717
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6034;